// Utility to check if agent is logged in (JWT present)
export function isAgentLoggedIn() {
  return !!sessionStorage.getItem('agentToken');
}
